<template>
  <single-panel-page>
    <div class="text-muted">
      <h4 class="text-4xl font-extrabold text-true-gray-900">
        404
      </h4>
      <p class="text-2xl font-semibold text-true-gray-600 sm:text-3xl">
        This page does not exist
      </p>
      <p
        class="mt-3 max-w-3xl text-lg text-true-gray-500 hover:text-true-gray-700"
      >
        <a href="/" class="flex items-center justify-center group px-3 py-1">
          <arrow-narrow-right-icon
            class="group-hover:mr-4 mr-2 transition-all duration-150"
          />
          <span class="transition-all duration-150">Back to dashboard</span>
        </a>
      </p>
    </div>
  </single-panel-page>
</template>

<script>
import { ArrowNarrowRightIcon } from '@vue-hero-icons/outline'

export default {
  components: {
    ArrowNarrowRightIcon,
  },
}
</script>
